module.exports = __webpack_public_path__ + "static/media/datasheet_onDemandPrinting_row1_product_image.280bf336.png";